
define('text!templates/modules/goal/edit/goal-edit-form.html',[],function () { return '<div class="form-content"></div>\n';});

